import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="mx-auto my-16 max-w-md text-center">
      <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Page not found</h1>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
        It may have been deleted, or you may not have access in this workspace.
      </p>
      <Link
        to="/"
        className="mt-5 inline-flex rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700 dark:bg-slate-100 dark:text-slate-950"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
